import Cookies from 'cookie-universal'

export const ANONYMOUS_ID = 'ajs_anonymous_id'

const getAnonymousId = () => Cookies().get(ANONYMOUS_ID) || null

export default getAnonymousId
